<app-share-button></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10 mt-2">
            <h2  >Payment Gateway Industry's Working</h2>
        </div>
        <div class="col-md-2 col2 ">
            <a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a> 
                </div> 
                   
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="5">
                    <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/fiAnbtH16Kw?si=vaIlO3JntZcLPgVv" 
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>

        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')"
        (mouseout)="showpayment(false,'2')" id="120"  >
           <h3>What are Payment Aggregators? </h3>
           <P>Payment aggregators are entities that facilitate online transactions between merchants and customers. They consolidate multiple merchants under a single merchant account or agreement, allowing these merchants to accept payments without needing to set up their own merchant accounts with payment processors or banks.</P>
        </div>
        
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')"
        (mouseout)="showpayment(false,'5')" id="121">
           <h3>Understanding the Players </h3>
           <h3>There are mainly four main players involved in the entire process:</h3>
        
        <div class="col-md-12 mt-3">
            <Label class="mt-4 spn" > <b>Merchants: </b> &nbsp; These are the businesses that sell goods or services online. </Label>
            <Label class="mt-4 spn" > <b>Customers: </b> &nbsp;These are the individuals who buy products or services from merchants. </Label>
            <Label class="mt-4 spn" > <b>Payment Gateways/Aggregators</b> &nbsp;These are service providers that facilitate online transactions between merchants and financial institutions. They handle the technical aspects of processing payments securely.</Label>
            <Label class="mt-4 spn" > <b>Acquirers: </b> &nbsp;These are financial institutions (such as banks) that have agreements to process the transactions.</Label>
         </div>
         </div>
         <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')"
         (mouseout)="showpayment(false,'3')" id="122">
            <label for="" class="spm" >Let's simplify the process of how a payment aggregator/payment gateway industry works, focusing on PayG which deals exclusively with merchants.</label>
         <div class="col-md-12 mt-3">
            <h3 class="mt-4 spn"> Let’s understand the process:</h3>
            <Label class="mt-4 spn" > <b>Step 1: Merchant Integration: </b> <br>Merchants sign up with a payment gateway/aggregator company. This involves creating an account and providing necessary business information. The payment gateway provides integration tools that allow merchants to incorporate payment processing into their websites or apps easily.</Label>
            <Label class="mt-4 spn" > <b>Step 2: Customer Checkout:</b> <br>When a customer decides to make a purchase, they go through the checkout process on the merchant's website or app. At checkout, the customer enters their payment information, such as credit card details. </Label>
            <Label class="mt-4 spn" > <b>Step 3: Transaction Encryption:</b> <br>The payment gateway encrypts the customer's payment information to ensure it's securely transmitted over the internet.</Label>
            <Label class="mt-4 spn" > <b>Step 4: Authorization Request:</b> <br>The payment gateway sends an authorization request to the acquirer associated with the customer's payment method (e.g., Visa, Mastercard).</Label>
            <Label class="mt-4 spn" > <b>Step 5: Authorization Process:</b> <br>The acquirer receives the authorization request and forwards it to the appropriate card network (e.g., Visa, Mastercard). The card network routes the request to the customer's bank to verify the payment details and account balance. </Label>
            <Label class="mt-4 spn" > <b>Step 6: Transaction Approval:</b> If the customer's bank approves the transaction, an authorization code is generated and sent back through the same channels. The acquirer receives the authorization code and forwards it to the payment gateway. <br> </Label>
            <Label class="mt-4 spn" > <b>Step 7: Notification to Merchant:</b> <br> The payment gateway notifies the merchant that the transaction has been authorized, allowing them to proceed with fulfilling the order. </Label>
            <Label class="mt-4 spn" > <b>Step 8: Funds Settlement:</b> <br> After the transaction is authorized, the payment gateway initiates the process of transferring funds from the customer's bank to the merchant's bank account. This settlement process typically takes a few business days to complete. </Label>
            <Label class="mt-4 spn" > <b>Step 9: Transaction Reporting and Management:</b> <br>The payment gateway provides tools for merchants to track and manage transactions, including reporting features for sales data and revenue analytics. </Label>
            <Label class="mt-4 spn" > <b>Step 10: Fees and Charges:</b> <br>Payment gateways/aggregators charge merchants a fee for each transaction processed. This fee varies depending on factors like transaction volume and the services provided. Acquirers may also charge fees to merchants for processing transactions, which can include interchange fees (paid to card networks) and acquirer fees. </Label>
            <Label class="mt-1 spn" > <br>In summary, the payment gateway/aggregator industry works by facilitating secure online transactions between merchants, customers, and financial institutions. Acquirers play a crucial role in processing transactions on behalf of merchants, working in collaboration with payment gateways to ensure smooth and efficient payment processing. </Label>
            
        </div>
        </div>

        
        <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'4')"
            (mouseout)="showpayment(false,'4')" id="123">
           <h3> Key Difference between payment gateways and payment aggregators </h3> 
            <Label class="mt-1 spn" > <br>The key difference between payment gateways and payment aggregators lies in their approach to facilitating online transactions and their target customers:</Label>
           <table class="table">
            <tr>
            <th class="tabled">S.No.</th>
            <th class="tabled">Payment Gateway</th>
            <th class="tabled">Payment Aggregator</th>
           </tr>
           <tr class="tabled">
            <td class="tabled">1.</td>
            <td class="tabled">Payment gateways primarily focus on ensuring secure transaction processing and data integrity.</td>
            <td class="tabled">Payment aggregators focus on providing a unified platform for processing various payment methods and offering payment services to multiple merchants.</td>
           </tr>
           <tr class="tabled">
            <td class="tabled">2.</td>
            <td class="tabled">Payment gateways require merchants to have their merchant accounts and establish relationships with acquiring banks.</td>
            <td class="tabled">Payment aggregators provide merchants with a shared merchant account and manage the relationship with acquiring banks on behalf of multiple merchants.</td>
            </tr>
            <tr class="tabled">
            <td class="tabled">3.</td>
            <td class="tabled">Payment gateways transmit encrypted payment data and verify transactions directly between the customer and the merchant's bank.</td>
            <td class="tabled">Payment aggregators collect payment data from multiple merchants and process transactions through their Merchant Identification Number (MID) before dispersing funds to individual merchant accounts.</td>
            </tr>
            <tr class="tabled">
            <td class="tabled">4.</td>
            <td class="tabled">Payment gateways often allow for more customization, allowing merchants to integrate payment processing seamlessly into their website or app.</td>
            <td class="tabled">Payment aggregators typically offer standardized payment processing solutions with fewer customization options but faster onboarding for merchants.</td>
            </tr>
           </table>
        </div>
        
        
    </div>

</div>
</div>
<div class="col-md-4 hide-tbl content2 ">
<div class="card crd p-4">
    <div class="row">
        <div class="col-md-12">
            <h5 >
                Table of Contents:
            </h5>

        </div>
        <div class="col-md-12 mt-2">
            
        </div>
        <div class="col-md-12 mt-3">
            <a href="#120">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                            > Payment Aggregators</span>
                       
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-3">
            <a href="#121">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                            > Key Players</span>
                       
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-3">
            <a href="#122">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                            >
                            How payment gateway/Aggregator work? </span>
                       
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-3">
            <a href="#123">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt=""> &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                            >Payment Gateway and Aggregator</span>
                       
                    </div>
                </div>
            </a>
        </div>
    </div>
</div>
</div>
<div class="col-md-9 hide ft-9">
    <hr>
    <div class=" row crd">
        <div class="col-md-8">
            <a [routerLink]="['/']">     <button class="btn btn-color" (click)="menues('Payment Gateway')" > <img
                    src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Introduction to Payment Gateway
            </button></a>
           
        </div>
        <div class="col-md-4    ">
            <a [routerLink]="['/onboarding']"> <button class="btn btn-color" (click)="menues('PayG')" >Onboarding
                &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            
        </div>
    </div>
</div>
</div>